import {Component, OnInit, Input, ViewChild} from "@angular/core";
import {Auth2Service} from "../../../../services/auth2.service";
import {ApiService} from "../../../../services/api.service";
import {Router} from "@angular/router";
import {UserService} from "../../services/users.service";
import {HttpErrorResponse} from "@angular/common/http";
import {
  StPagination2Component
} from "../../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {PageChangeDto} from "../../../../models/page-change-dto";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-funding-goals-listing',
  templateUrl: './funding-goals-listing.component.html',
  styleUrls: ['./funding-goals-listing.component.scss'],
  standalone: false
})
export class FundingGoalsListingComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Funding Goals', path: 'app/users/dashboard/funding-goals/all'}
  ];

  @Input()
  fundingGoals: any[] = [];

  sortedAscFundingGoalName: boolean = false;
  sortedAscDueDate: boolean = false;
  sortedAscFundingGoalAmt: boolean = false;
  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;

  @ViewChild('fundinggoalspaginator') stPaginator2Component!: StPagination2Component;
  page: number = 1;
  collectionSize: number = 0;
  pageSize: number = 15;
  customPageSizes = [
    {
      "pageSizeId" : 5,
      "pageSize": 5
    }, {
      "pageSizeId" : 10,
      "pageSize": 10
    },{
      "pageSizeId" : 15,
      "pageSize": 15
    }, {
      "pageSizeId" : 25,
      "pageSize": 25
    }, {
      "pageSizeId" : 50,
      "pageSize": 50
    }
  ];
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService: UserService,
              private routerChild: Router, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy All Funding Goals");
  }

  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    if (this.username) {
      this.userService.getAllFundingGoalsPages(this.page, this.pageSize, this.username, this.impersonatedEmail).subscribe((result: any) => {
        if (result && result.body) {
          this.fundingGoals = result.body.dtos;
          this.collectionSize = result.body.collectionSize;
          this.page = result.body.page;
          this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
        }
      }, (err: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Funding goal fetch failure',
          detail: 'Failed to pull all funding goals...',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      });
    }
  }

  changePageResults(pageChangeDto: PageChangeDto): void {
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.pageSize = pageChangeDto["pageSize"]
    }
    this.userService.getAllFundingGoalsPages(updatePageValue, this.pageSize, this.username, this.impersonatedEmail)
      .subscribe((result : any) => {
        if (result && result.body) {
          this.fundingGoals = result.body.dtos;
          this.page = updatePageValue
          this.collectionSize = result.body.collectionSize
        }
      }, (err: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Funding goal fetch failure',
          detail: 'Failed to pull funding goals...',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      })
  }

  sortTextFundingGoalName(): void {
    if (!this.sortedAscFundingGoalName) {
      this.fundingGoals = this.apiService.sortTextDesc('fundingGoalName', this.fundingGoals);
    } else {
      this.fundingGoals = this.apiService.sortTextAsc('fundingGoalName', this.fundingGoals)
    }
    this.sortedAscFundingGoalName = !this.sortedAscFundingGoalName
  }

  sortDueDate(): void {
    if (!this.sortedAscDueDate) {
      this.fundingGoals = this.apiService.sortDateDesc('fundingDueDate', this.fundingGoals);
    } else {
      this.fundingGoals = this.apiService.sortDateAsc('fundingDueDate', this.fundingGoals)
    }
    this.sortedAscDueDate = !this.sortedAscDueDate
  }

  sortNumberFundingGoalAmt(): void {
    if (!this.sortedAscDueDate) {
      this.fundingGoals = this.apiService.sortTextDesc('fundingAmtNeeded', this.fundingGoals);
    } else {
      this.fundingGoals = this.apiService.sortTextAsc('fundingAmtNeeded', this.fundingGoals)
    }
    this.sortedAscDueDate = !this.sortedAscDueDate
  }

  onCancel(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }

  onAddFundingGoal(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/create');
  }

  onEditFundingGoal(fundingGoal: any): void {
    this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/' + fundingGoal['fundingGoalId'] + '/edit');
  }

  onViewFundingGoal(fundingGoal: any): void {
    this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/' + fundingGoal['fundingGoalId'] + '/view');
  }

  onDeleteFundingGoal(fundingGoal: any): void {
    if (this.username) {
      this.userService.deleteFundingGoal(fundingGoal['fundingGoalId'], this.username, this.impersonatedEmail).subscribe((result: any) => {
        if (result && result.body) {
          this.fundingGoals = result.body;
        }
      }, (err: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Funding goal deletion failure',
          detail: 'Failed to delete the Funding Goal...',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      });
    } else {
      this.pageErrorMessages.push({
        field: 'Login failure',
        detail: 'Username is not logged in.',
        severity: 'error'
      });
      this.showErrorMessagesToUser();
      this.routerChild.navigateByUrl('app/login');
    }
  }

  protected readonly Date = Date;
}
